<template>
  <sea-page title="Home">
    <home-widget
      title="Aziende"
      icon="mdi-domain"
      :bgColor="colors.primarycolor"
      dark
      width="100%"
      :closeButton="false"
    >
      <div class="d-flex justify-end mr-3">
        <div style="width: 400px">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Ricerca rapida"
            single-line
            hide-details
            @click:append="load"
            color="success"
          ></v-text-field>
        </div>
      </div>
      <v-data-table
        :loading="dataLoading"
        loading-text="Attendere"
        :headers="headers"
        :footer-props="footerProps"
        :items="items"
        sort-by="ragioneSociale"
        dense
        :items-per-page="-1"
        height="calc(100vh - 225px)"
      >
        <template v-slot:item.c1="{ item }">
          <v-row no-gutters class="mb-2">
            <v-col cols="12">
              <div class="title">{{ item.ragioneSociale }} {{ item.nome }}</div>
            </v-col>
            <v-col cols="2">
              <div class="text-truncate text-little">
                Partita iva: {{ item.partitaIva }}<br />
                CF: {{ item.codiceFiscale }}
              </div>
            </v-col>
            <v-col cols="3">
              <div class="d-flex flex-row" style="overflow: hidden">
                <v-icon :color="colors.primarycolor" left>mdi-map-marker</v-icon>
                <div
                  class="d-flex align-center text-truncate text-caption"
                  style="height: 40px"
                >
                  {{ item.sLegIndirizzo }}<br />{{ item.sLegCap }}
                  {{ item.sLegComune }} ({{ item.sLegPr }})
                </div>
              </div>
              <div class="d-flex flex-row" style="overflow: hidden">
                <v-icon :color="colors.primarycolor" left>mdi-email</v-icon>
                <div class="d-flex align-center text-truncate text-caption">
                  {{ item.email }}
                </div>
              </div>
            </v-col>
            <v-col cols="2">
              <div class="d-flex flex-row" style="overflow: hidden">
                <v-icon :color="colors.primarycolor" left>mdi-phone</v-icon>
                <div
                  class="d-flex align-center text-truncate text-caption"
                  style="height: 40px"
                >
                  <div>{{ item.sLegTelPref }} - {{ item.sLegTelefono }}</div>
                </div>
              </div>
              <div class="d-flex flex-row" style="overflow: hidden">
                <v-icon :color="colors.primarycolor" left>mdi-cellphone</v-icon>
                <div class="d-flex align-center text-truncate text-caption">
                  {{ item.sLegCellulare }}
                </div>
              </div>
            </v-col>
            <v-col cols="2" class="ml-2">
              <div class="d-flex flex-row" style="overflow: hidden">
                <div
                  class="d-flex align-center text-truncate text-caption"
                  style="height: 40px"
                >
                  N. Filiali
                  <span class="ml-2 text-colored">{{ item.numFiliali }}</span>
                </div>
              </div>
              <div class="d-flex flex-row" style="overflow: hidden">
                <div class="d-flex align-center text-truncate text-caption">
                  N. lavoratori retribuiti
                  <span class="ml-2 text-colored">{{
                    item.lavoratoriRetribuiti
                  }}</span>
                </div>
              </div>
            </v-col>
            <v-col cols="2" class="ml-2 px-2">
              <div class="d-flex flex-row" style="overflow: hidden">
                <div
                  class="d-flex align-center text-truncate text-caption"
                  style="height: 40px"
                >
                  Retribuzioni pagate
                </div>
              </div>
              <div class="d-flex flex-row" style="overflow: hidden">
                <div class="d-flex align-center text-truncate text-caption">
                  <span class="text-colored">{{
                    item.retribuzioniPagate | currencyFormat
                  }}</span>
                </div>
              </div>
            </v-col>
          </v-row>
        </template>
        <template v-slot:item.c2="{ item }">
          <v-btn
            :color="colors.primarycolor"
            x-small
            fab
            dark
            @click="gotoWidgets(item.codiceFiscale)"
          >
            <v-icon dark> mdi-eye </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </home-widget>
  </sea-page>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import HomeWidget from "@/components/Widgets/Widget.vue";
import mixin from "@/mixin";

const headers = [
  { value: "c1", fileterable: false, sortable: false },
  { value: "c2", fileterable: false, sortable: false },
];
const footerProps = {
  itemsPerPageAllText: "Tutte",
  itemsPerPageText: "Righe per pagina",
};
export default {
  name: "Home",
  mixins: [mixin],
  components: {
    HomeWidget,
  },
  mounted() {
    this.fetchCompany().then(() => (this.dataLoading = false));
  },
  data() {
    return {
      headers,
      footerProps,
      dataLoading: true,
      search: null,
    };
  },
  methods: {
    ...mapActions({
      fetchCompany: "proxy/fetchListahomecons",
    }),
    gotoWidgets(id) {
      this.$router.push({
        path: "/company/home",
        query: { codiceAzienda: id },
      });
    },
    load() {
      this.dataLoading = true;
      this.fetchCompany(this.search).then(() => (this.dataLoading = false));
    },
  },
  computed: {
    ...mapGetters({
      items: "proxy/companies",
    }),
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';
.text-colored {
  color: $systemcolor;
  font-weight: bold;
}
</style>